<template>
  <div class="container page">
    <van-nav-bar class="nav-bar" :title="$t('修改登录密码')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
      </template>
      <template #right>
        <span class="nav-right" @click="save()">{{ $t('保存') }}</span>
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-field v-model="old_password" :label="$t('旧密码')" :placeholder="$t('请输入您的旧密码')"/>
      <van-field v-model="o_new_password" :label="$t('新密码')" :placeholder="$t('请输入您的新密码')"/>
      <van-field v-model="t_new_password" :label="$t('新密码')" :placeholder="$t('请再次输入您的新密码')"/>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password: "",
      t_new_password: "",
      old_password: "",
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    save() {
      if (this.o_new_password === "" || this.o_new_password === null || this.o_new_password === undefined) {
        this.$toast.fail(this.$t("请填写完整") + "！");
        return false;
      }
      if (this.t_new_password === "" || this.t_new_password === null || this.t_new_password === undefined) {
        this.$toast.fail(this.$t("请填写完整") + "！");
        return false;
      }
      if (this.old_password === "" || this.old_password === null || this.old_password === undefined) {
        this.$toast.fail(this.$t("请填写完整") + "！");
        return false;
      }
      if (this.o_new_password !== this.t_new_password) {
        this.$toast(this.$t("两次密码输入不一致"));
        return false;
      }
      this.$http({
        method: 'get',
        data: {
          old_password: this.old_password,
          new_password: this.o_new_password,
        },
        url: 'user_set_loginpw'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg);
          setTimeout(() => {
            localStorage.clear()
            this.$router.push("Login")
          }, 500);

        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.van-cell {
  font-size: 35px;
  line-height: 80px;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }

  ::v-deep .nav-right {
    font-size: 17px !important; /* 30px * 0.5733 ≈ 17px */
  }

  // 输入框PC端适配
  .van-cell {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
    line-height: 46px; /* 80px * 0.5733 ≈ 46px */
  }
}
</style>
